module.exports = __webpack_public_path__ + "img/sfn_icon.58204722.png";